export default __webpack_public_path__ + "static/media/asterix-rouge.80feb92f.svg";